import { getContentPath } from './utils';

const getStroke = (table, cell, content, canvasState) => {
    const oldShape = canvasState.getIn(getContentPath(table, cell, content, canvasState));

    return oldShape.toJS().stroke;
};

export default getStroke;
